module.exports = __webpack_public_path__ + "assets/img/modal-avatar-aed19f76.png";